import {
    apiCguCreateBoton,
    apiCguCreateModulo,
    apiCguCreateSubmodulo,
    apiCguGetPermisoPerfil,
    apiCguGetUsuariosPermisos,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import {
    getFormBoton,
    getFormModulo,
    getFormSubmodulo,
    getModelBoton,
    getModelModulo,
    getModelSubmodulo,
} from "../models/SistemaModel";

import { fnHandleChangeText } from "../settings/handleConfig";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const SistemaContext = createContext();

export function SistemaProvider(props) {
    const { usuarioSesion, handleChangeUsuarioPermisos } = useLogin();
    const { Get, Post } = useRequest();

    const [listaSistemaModulos, setListaSistemaModulos] = useState([]);
    const [moduloSeleccionado, setModuloSeleccionado] = useState(getModelModulo());
    const [submoduloSeleccionado, setSubmoduloSeleccionado] = useState(getModelSubmodulo());
    const [botonSeleccionado, setBotonSeleccionado] = useState(getModelBoton());
    const [modalOpenFormModulo, setModalOpenFormModulo] = useState(false);
    const [modalOpenEliminarModulo, setModalOpenEliminarModulo] = useState(false);
    const [modalOpenFormSubmodulo, setModalOpenFormSubmodulo] = useState(false);
    const [modalOpenEliminarSubmodulo, setModalOpenEliminarSubmodulo] = useState(false);
    const [modalOpenFormBoton, setModalOpenFormBoton] = useState(false);
    const [modalOpenEliminarBoton, setModalOpenEliminarBoton] = useState(false);
    const [formModulo, setFormModulo] = useState(getFormModulo());
    const [formSubmodulo, setFormSubmodulo] = useState(getFormSubmodulo());
    const [formBoton, setFormBoton] = useState(getFormBoton());

    const handleOpenFormModulo = (value) => {
        setModalOpenFormModulo(value);
    };

    const handleOpenEliminarModulo = (value) => {
        setModalOpenEliminarModulo(value);
    };

    const handleOpenFormSubmodulo = (value) => {
        setModalOpenFormSubmodulo(value);
    };

    const handleOpenEliminarSubmodulo = (value) => {
        setModalOpenEliminarSubmodulo(value);
    };

    const handleOpenFormBoton = (value) => {
        setModalOpenFormBoton(value);
    };

    const handleOpenEliminarBoton = (value) => {
        setModalOpenEliminarBoton(value);
    };

    const handleChangeFormModulo = fnHandleChangeText(formModulo, setFormModulo);
    const handleChangeFormSubmodulo = fnHandleChangeText(formSubmodulo, setFormSubmodulo);
    const handleChangeFormBoton = fnHandleChangeText(formBoton, setFormBoton);

    const handleClickNuevoModulo = () => {
        const modulo = getModelModulo();
        fnFillFormModulo(modulo);
        setModuloSeleccionado(modulo);
        setModalOpenFormModulo(true);
    };

    const handleClickEditarModulo = (e, modulo) => {
        e.stopPropagation();
        fnFillFormModulo(modulo);
        setModuloSeleccionado(modulo);
        setModalOpenFormModulo(true);
    };

    const handleClickEliminarModulo = (e, modulo) => {
        e.stopPropagation();
        setModuloSeleccionado(modulo);
        setModalOpenEliminarModulo(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerElementosSistema();
    };

    const handleClickNuevoSubmodulo = (e, modulo) => {
        e.stopPropagation();
        const submodulo = {
            ...getModelSubmodulo(),
            iIdModulo: modulo.iIdModulo,
        };
        fnFillFormSubmodulo(submodulo);
        setSubmoduloSeleccionado(submodulo);
        setModalOpenFormSubmodulo(true);
    };

    const handleClickEditarSubmodulo = (e, submodulo) => {
        e.stopPropagation();
        fnFillFormSubmodulo(submodulo);
        setSubmoduloSeleccionado(submodulo);
        setModalOpenFormSubmodulo(true);
    };

    const handleClickEliminarSubmodulo = (e, submodulo) => {
        e.stopPropagation();
        setSubmoduloSeleccionado(submodulo);
        setModalOpenEliminarSubmodulo(true);
    };

    const handleClickNuevoBoton = (e, submodulo) => {
        e.stopPropagation();
        const boton = {
            ...getModelBoton(),
            iIdModulo: submodulo.iIdModulo,
            iIdSubModulo: submodulo.iIdSubModulo,
        };
        fnFillFormBoton(boton);
        setBotonSeleccionado(boton);
        setModalOpenFormBoton(true);
    };

    const handleClickEditarBoton = (e, boton) => {
        e.stopPropagation();
        fnFillFormBoton(boton);
        setBotonSeleccionado(boton);
        setModalOpenFormBoton(true);
    };

    const handleClickEliminarBoton = (e, boton) => {
        e.stopPropagation();
        setBotonSeleccionado(boton);
        setModalOpenEliminarBoton(true);
    };

    const handleSubmitFormModulo = (e) => {
        fnPrevent(e);

        const { txtNombre } = formModulo;
        const form = {
            ...formModulo,
            txtNombre: { ...txtNombre, error: txtNombre.value === "" },
        };
        setFormModulo(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entModulo = {
            iIdModulo: moduloSeleccionado.iIdModulo,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: txtNombre.value,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarModulo(entModulo);
    };

    const handleSubmitFormSubmodulo = (e) => {
        fnPrevent(e);

        const { txtIdModulo, txtNombre } = formSubmodulo;
        const form = {
            ...formSubmodulo,
            txtIdModulo: { ...txtIdModulo, error: txtIdModulo.value === "" || parseInt(txtIdModulo.value) === 0 },
            txtNombre: { ...txtNombre, error: txtNombre.value === "" },
        };
        setFormSubmodulo(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entSubmodulo = {
            iIdModulo: submoduloSeleccionado.iIdModulo,
            iIdSubModulo: submoduloSeleccionado.iIdSubModulo,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: txtNombre.value,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarSubmodulo(entSubmodulo);
    };

    const handleSubmitFormBoton = (e) => {
        fnPrevent(e);

        const { txtIdModulo, txtIdSubmodulo, txtNombre } = formBoton;
        const form = {
            ...formBoton,
            txtIdModulo: { ...txtIdModulo, error: txtIdModulo.value === "" || parseInt(txtIdModulo.value) === 0 },
            txtIdSubmodulo: {
                ...txtIdSubmodulo,
                error: txtIdSubmodulo.value === "" || parseInt(txtIdSubmodulo.value) === 0,
            },
            txtNombre: { ...txtNombre, error: txtNombre.value === "" },
        };
        setFormBoton(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entBoton = {
            iIdModulo: botonSeleccionado.iIdModulo,
            iIdSubModulo: botonSeleccionado.iIdSubModulo,
            iIdBoton: botonSeleccionado.iIdBoton,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: txtNombre.value,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarBoton(entBoton);
    };

    const handleSubmitEliminarModulo = () => {
        const entModulo = {
            iIdModulo: moduloSeleccionado.iIdModulo,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: null,
            bActivo: false,
            bBaja: true,
        };

        fnEliminarModulo(entModulo);
    };

    const handleSubmitEliminarSubmodulo = () => {
        const entSubmodulo = {
            iIdModulo: submoduloSeleccionado.iIdModulo,
            iIdSubModulo: submoduloSeleccionado.iIdSubModulo,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: null,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarSubmodulo(entSubmodulo);
    };

    const handleSubmitEliminarBoton = () => {
        const entBoton = {
            iIdModulo: botonSeleccionado.iIdModulo,
            iIdSubModulo: botonSeleccionado.iIdSubModulo,
            iIdBoton: botonSeleccionado.iIdBoton,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: null,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarBoton(entBoton);
    };

    const fnFillFormModulo = (modulo) => {
        const model = getFormModulo();
        const { txtIdModulo, txtNombre } = model;
        setFormModulo({
            ...model,
            txtIdModulo: {
                ...txtIdModulo,
                value: !modulo.iIdModulo ? "" : modulo.iIdModulo,
            },
            txtNombre: {
                ...txtNombre,
                value: !modulo.sNombre ? "" : modulo.sNombre,
            },
        });
    };

    const fnFillFormSubmodulo = (submodulo) => {
        const model = getFormSubmodulo();
        const { txtIdModulo, txtIdSubmodulo, txtNombre } = model;
        setFormSubmodulo({
            ...model,
            txtIdModulo: {
                ...txtIdModulo,
                value: !submodulo.iIdModulo ? "" : submodulo.iIdModulo,
            },
            txtIdSubmodulo: {
                ...txtIdSubmodulo,
                value: !submodulo.iIdSubModulo ? "" : submodulo.iIdSubModulo,
            },
            txtNombre: {
                ...txtNombre,
                value: !submodulo.sNombre ? "" : submodulo.sNombre,
            },
        });
    };

    const fnFillFormBoton = (boton) => {
        const model = getFormBoton();
        const { txtIdModulo, txtIdSubmodulo, txtIdBoton, txtNombre } = model;
        setFormBoton({
            ...model,
            txtIdModulo: {
                ...txtIdModulo,
                value: !boton.iIdModulo ? "" : boton.iIdModulo,
            },
            txtIdSubmodulo: {
                ...txtIdSubmodulo,
                value: !boton.iIdSubModulo ? "" : boton.iIdSubModulo,
            },
            txtIdBoton: {
                ...txtIdBoton,
                value: !boton.iIdBoton ? "" : boton.iIdBoton,
            },
            txtNombre: {
                ...txtNombre,
                value: !boton.sNombre ? "" : boton.sNombre,
            },
        });
    };

    const fnObtenerElementosSistema = async (iIdPerfil = null) => {
        const payload = {
            loader: "Consultando elementos del sistemas...",
            url: apiCguGetPermisoPerfil + "?iIdPerfil=" + iIdPerfil,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaSistemaModulos(response.Result);
        }
    };

    const fnUpdPermisos = async () => {
        const payload = {
            loader: "Obteniendo permisos...",
            url: apiCguGetUsuariosPermisos + "?piIdPerfil=" + usuarioSesion.iIdPerfil,
            alert: true,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            handleChangeUsuarioPermisos(response.Result);
        }
    };

    const fnGuardarModulo = async (entModulo) => {
        const payload = {
            loader: "Guardando módulo...",
            url: apiCguCreateModulo,
            body: entModulo,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormModulo(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
        fnPreventBlur();
    };

    const fnEliminarModulo = async (entModulo) => {
        const payload = {
            loader: "Eliminando módulo...",
            url: apiCguCreateModulo,
            body: entModulo,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarModulo(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
    };

    const fnGuardarSubmodulo = async (entSubmodulo) => {
        const payload = {
            loader: "Guardando submódulo...",
            url: apiCguCreateSubmodulo,
            body: entSubmodulo,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormSubmodulo(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
        fnPreventBlur();
    };

    const fnEliminarSubmodulo = async (entSubmodulo) => {
        const payload = {
            loader: "Eliminando submódulo...",
            url: apiCguCreateSubmodulo,
            body: entSubmodulo,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarSubmodulo(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
    };

    const fnGuardarBoton = async (entBoton) => {
        const payload = {
            loader: "Guardando botón...",
            url: apiCguCreateBoton,
            body: entBoton,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormBoton(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
        fnPreventBlur();
    };

    const fnEliminarBoton = async (entBoton) => {
        const payload = {
            loader: "Eliminando botón...",
            url: apiCguCreateBoton,
            body: entBoton,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarBoton(false);
            await fnUpdPermisos();
            await fnObtenerElementosSistema();
        }
        fnPreventBlur();
    };

    return (
        <SistemaContext.Provider
            value={{
                listaSistemaModulos,
                moduloSeleccionado,
                submoduloSeleccionado,
                botonSeleccionado,
                modalOpenFormModulo,
                modalOpenEliminarModulo,
                modalOpenFormSubmodulo,
                modalOpenEliminarSubmodulo,
                modalOpenFormBoton,
                modalOpenEliminarBoton,
                formModulo,
                formSubmodulo,
                formBoton,
                handleOpenFormModulo,
                handleOpenEliminarModulo,
                handleOpenFormSubmodulo,
                handleOpenEliminarSubmodulo,
                handleOpenFormBoton,
                handleOpenEliminarBoton,
                handleChangeFormModulo,
                handleChangeFormSubmodulo,
                handleChangeFormBoton,
                handleClickNuevoModulo,
                handleClickEditarModulo,
                handleClickEliminarModulo,
                handleClickRefrescarDatos,
                handleClickNuevoSubmodulo,
                handleClickEditarSubmodulo,
                handleClickEliminarSubmodulo,
                handleClickNuevoBoton,
                handleClickEditarBoton,
                handleClickEliminarBoton,
                handleSubmitFormModulo,
                handleSubmitFormSubmodulo,
                handleSubmitFormBoton,
                handleSubmitEliminarModulo,
                handleSubmitEliminarSubmodulo,
                handleSubmitEliminarBoton,
            }}
        >
            {props.children}
        </SistemaContext.Provider>
    );
}

export function useSistema() {
    return useContext(SistemaContext);
}
